import React, { useContext } from 'react';
import { ResponsiveGrid, Tab } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AnnualSchedule from './components/AnnualSchedule';
import styles from './index.module.scss';
import MaintainPlanList from '../MaintainPlan/components/MaintainPlanList';
import LongRepairPlanList from '../LongRepairPlan/components/LongRepairPlanList';
import Consumables from './components/Consumables';
import { BackStageContext } from '@/contexts/BackStageContext';

const { Cell } = ResponsiveGrid;

const Maintenance = () => {
  const { backStageUpdateTrigger, setBackStageUpdateTrigger } =
    useContext(BackStageContext);

  return (
    <ResponsiveGrid gap={20}>
      <Cell colSpan={12}>
        <PageHeader
          title="維運管理"
          breadcrumbs={[
            {
              name: '智慧建築專區',
            },
            {
              name: '維運管理',
            },
          ]}
        />
      </Cell>

      <Cell colSpan={12}>
        <Tab>
          <Tab.Item title="設施設備維護管理">
            <div className={styles.content}>
              <h2>年度計畫表</h2>
              <AnnualSchedule {...{ backStageUpdateTrigger }} />
            </div>
            <div className={styles.content}>
              <h2>年度維護計畫(含預算)</h2>
              <MaintainPlanList
                {...{ backStageUpdateTrigger, setBackStageUpdateTrigger }}
              />
            </div>
          </Tab.Item>
          <Tab.Item title="資（耗）材設備管理">
            <div className={styles.content}>
              <h2>資（耗）材設備管理</h2>
              <Consumables />
            </div>
          </Tab.Item>
          <Tab.Item title="長期修繕計畫">
            <div className={styles.content}>
              <h2>長期修繕計畫</h2>
              <LongRepairPlanList
                {...{ backStageUpdateTrigger, setBackStageUpdateTrigger }}
              />
            </div>
          </Tab.Item>
        </Tab>
      </Cell>
    </ResponsiveGrid>
  );
};

export default Maintenance;
